import {Injectable} from '@angular/core';
import {deleteDoc, doc, Firestore, getDoc, setDoc, writeBatch} from '@angular/fire/firestore';
import {Store} from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class CollectionUsersMessagesService {

  constructor(
    private readonly store: Store,
    private firestore: Firestore,
  ) {
  }

  // ====================================================================================================
  // Generic Get/Set/Delete
  // ====================================================================================================

  async setDocument<DataType>(
    path: string,
    data: DataType,
  ): Promise<void> {
    try {
      const docRef = doc(this.firestore, path);
      await setDoc(docRef, data, {merge: true});
    } catch (error) {
      console.error(error);
    }
  }

  async getDocument<DataType>(
    path: string,
  ): Promise<DataType> {
    try {
      const docRef = doc(this.firestore, path);
      const docSnapshot = await getDoc(docRef);
      if (docSnapshot.exists()) {
        return docSnapshot.data() as DataType;
      } else {
        return {} as DataType;
      }
    } catch (error) {
      console.error(error);
    }
  }

  async deleteDocument<DataType>(
    path: string,
  ): Promise<void> {
    try {
      const docRef = doc(this.firestore, path);
      await deleteDoc(docRef);
    } catch (error) {
      console.error(`Error deleting document at path: ${path}\n`, error);
    }
  }

  batchDeleteMessages(messageIds: string[], userId: string, storeId: string): Promise<void> {
    const batch = writeBatch(this.firestore);
    messageIds.forEach((id: string) => {
      const messageRef = doc(this.firestore, `/notifications/${id}`);
      batch.delete(messageRef);
    });
    return batch.commit();
  }
}
